import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DocumentsUploadModalComponent, GungFlowService, NavbarConfigService } from 'gung-standard';

@Component({
    selector: 'tylo-tylo-documents-upload-modal',
    templateUrl: './tylo-documents-upload-modal.component.html',
    styleUrls: ['./tylo-documents-upload-modal.component.css'],
    standalone: false
})
export class TyloDocumentsUploadModalComponent extends DocumentsUploadModalComponent {
  @Input()
  uploadMethodExt: (
    file: File[],
    fileDescription: string,
    inMenu: boolean,
    showInDocumentView: boolean,
    userGroups: any,
    includedAssortments: string,
    includedCustomers: string,
    excludedCustomers: string
  ) => Promise<boolean>;

  advanced = false;

  includedAssortments = '';
  includedCustomers = '';
  excludedCustomers = '';

  constructor(
    http: HttpClient,
    activeModal: NgbActiveModal,
    navbarConfigService: NavbarConfigService,
    gungFlowService: GungFlowService
  ) {
    super(http, activeModal, navbarConfigService, gungFlowService);
  }

  onUploadTylo(inputFile, inputDescription, inputInMenu, inputShowInDocumentView) {
    if (!inputFile.files || inputFile.files.length === 0) {
      return;
    }
    this.spinner = true;
    const files: File[] = inputFile.files;
    const fileDescription: string = inputDescription.value;
    const inMenu: boolean = inputInMenu.checked;
    const showInDocumentView: boolean = inputShowInDocumentView.checked;
    this.uploadMethodExt(
      files,
      fileDescription,
      inMenu,
      showInDocumentView,
      this.selectedGroups,
      this.includedAssortments,
      this.includedCustomers,
      this.excludedCustomers
    ).then(
      () => {
        this.activeModal.close(true);
        this.spinner = false;
      },
      error => {
        console.log('error', error);
        this.spinner = false;
      }
    );
  }
}
